<template>
  <div class="static-div" v-for="tag in getTagsList(mc_final_options)">
    <div class="px-4 py-4 ">
      <div class=" px-4 py-3 pt-4 rounded  " :style="{background : getColor(tag.name) }">
        <ul>
          <li class="flex flex-wrap justify-between pb-4 relative uppercase ">
            <div class="w-full flex flex-nowrap">
              <div class=" flex w-full flex-nowrap">
                <div
                  class="cursor-pointer max-w-[60%]  w-full">
                  {{ tag.name }}
                </div>
              </div>
            </div>
          </li>
          <li v-if="tag.recipes.length > 0" v-for="(mc_option_recipe, index1) in tag.recipes"
            class="flex flex-nowrap justify-between pb-4 cursor-pointer group"
            :title="$helpers.getByName(mc_option_recipe.total_val)" @mouseleave="is_show = false">
            <div class="flex gap-2 w-full justify-between ">
              <div class="text-sm font-bold text-color-first-li">
                <a target="_blank" :href="route('recipes-edit', { id: mc_option_recipe.id })">
                  {{ mc_option_recipe.name }}
                </a>
              </div>
              <div>
                <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                  <span class="">
                    {{ $helpers.getByFirstName(mc_option_recipe.total_val) }}
                  </span>
                </div>
                <div class="ml-auto relative hidden group-hover:block min-w-[80px]">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                                fill="currentColor" @click="is_show = !is_show"
                                if="hoveredIndex === mc_option_recipe.id + element.id">
                                <path
                                  d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                              </svg>

                              <div v-if="is_show" class="bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10">
                                <ul class="w-full cursor-default">
                                  <li class="px-4 text-black hover:bg-gray-200"
                                   v-for="(value, key) in send" :key="key">
                                    <button type="button" @click="sendRecipe(
                                        mc_option_recipe, key, tag
                                      )">
                                      {{ value }}
                                    </button>
      </li>
                                  <li class="px-4 text-black hover:bg-gray-200">
                                    
                                  </li>
                                </ul>
                              </div>
                            </div>
              </div>
            </div>
          </li>
          <li v-else>
            "Send to first Recipe to {{ tag.name }}"
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Inertia
  } from "@inertiajs/inertia";


  import vClickOutside from "click-outside-vue3";

  export default {
    props: [
      'isOpenTagModel',
      'mc_final_options',
      'default_tag','day_tag', 'shared_letters'
    ],

    directives: {
      clickOutside: vClickOutside.directive,
    },

    components: {
      
    },
    name: "large-modal",
    data() {
      return {
        // isVisible: this.isOpenTagModel,
        isVisible: true,
        is_show: false,
        
        send : {
          'all' : 'Send to ALL Days',
          'mon' : 'Send to Monday',
          'tue' : 'Send to Tuesday',
          'wed' : 'Send to Wednesday',
          'thu' : 'Send to Thursday',
          'fri' : 'Send to Friday',
          'sat' : 'Send to Saturday',
          'sun' : 'Send to Sunday',
        },
      }

    },

    methods: {
      checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
      getTagsList(elementDay) {
        const tagsMap = new Map();
        elementDay.forEach((option) => {
          // console.log("getTagsList option", option);

          if (!option.tags) {
              option.tags = []; // Initialize as an empty array if undefined
            }
          option.tags.forEach((tag) => {
            const tagName = tag.name.toLowerCase();

            if (!tagsMap.has(tagName)) {
              tagsMap.set(tagName, {
                name: tag.name,
                color: tag.color,
                is_default: tag.is_default,
                recipes: []
              });
            }
          });
          option.recipes.forEach((recipe) => {
            if (!recipe.tags) {
              recipe.tags = []; // Initialize as an empty array if undefined
            }
            recipe.tags.forEach((rTag) => {
              const tagName = rTag.name.toLowerCase();

              if (tagsMap.has(tagName)) {
                // console.log('getTagsList recipe 1');
                let tagEntry = tagsMap.get(tagName);

                if (!tagEntry.recipes.some(r => r.id === recipe.id)) {
                  tagEntry.recipes.push(recipe);
                }
              }
            });
          });
        });

        let recipes = this.getDefaultRecipes(elementDay);
        if(recipes.length > 0){
          let tn = this.$page.props.default_tag.toLowerCase();     
          tagsMap.set(tn, {
                name: this.default_tag?.name,
                color: this.default_tag?.color,
                is_default: this.default_tag?.is_default,
                recipes: recipes
              });
        }

        return Array.from(tagsMap.values());
      },
      getCommonRecipes(elementDay) {
        if (elementDay.length === 0) return [];

        // Initialize with the first option's recipe IDs
        let commonRecipeIds = new Set(elementDay[0].recipes.map(recipe => recipe.id));

        // Iterate over remaining options and find intersection
        elementDay.forEach((option) => {
          const currentRecipeIds = new Set(option.recipes.map(recipe => recipe.id));

          // Keep only recipes that are present in all options
          commonRecipeIds = new Set([...commonRecipeIds].filter(id => currentRecipeIds.has(id)));
        });

        // Retrieve full recipe objects
        const allRecipes = elementDay.flatMap(option => option.recipes);
        const commonRecipes = [...commonRecipeIds].map(id => allRecipes.find(recipe => recipe.id === id));

        return commonRecipes;
      },
      getDefaultRecipes(elementDay) {
        const recipes = elementDay.flatMap(option => option.recipes);
        // Filter recipes with `is_default` tag
        const defaultRecipes = recipes.filter(recipe =>
          recipe.tags.some(tag => tag.is_default)
        );
        // Remove duplicates using a Map (ensures unique recipes by ID)
        const uniqueRecipes = Array.from(
          new Map(defaultRecipes.map(recipe => [recipe.id, recipe])).values()
        );

        return uniqueRecipes;
      },

      sendRecipe(mc_option_recipe, key, tag) {
        // this.is_show = false;
        console.log('sendRecipe', mc_option_recipe);
        let recipe = JSON.stringify(mc_option_recipe);
        recipe = JSON.parse(recipe);
        console.log('sendRecipe', recipe);
        recipe.option_component_id = null;
        this.$emit('sendRecipe', recipe, key, {
          name: tag.name, color: tag.color, is_default: tag.is_default});
      },
      getColor(tagName) {
        let dColor = '#ffffff';
        if(this.shared_letters['all receives'])
        {
          dColor = this.shared_letters['all receives']
        }
        
        if(this.day_tag && this.day_tag.length > 0)
        {
          const index = this.day_tag.findIndex(dayTag => dayTag.name === tagName)
          if (index === -1) return dColor

          // Convert index to alphabet: 0 -> A, 1 -> B, etc.
          const letter = String.fromCharCode(65 + index)
          return this.shared_letters[letter] || dColor
        } 
        return dColor;
      },
    },
  };
</script>

<style>
  .searching-background-color {
    background-color: #38558e;
  }

  .button-bg-color-wed-menu2-gray {
    border: none !important;
    min-height: 35px;
    min-width: 35px;
  }

  .button-bg-color-wed-menu2 {
    background-color: #38558e;
    border: none !important;
    min-height: 35px;
    min-width: 35px;
  }

  .menu1-icon-color {
    color: #38558e;
  }

  .cancel-background-color {
    background-color: #8b8b8b;
  }

  .placeholder-background-color {
    background-color: #f8f8f8;
  }

  .mt-0-down {
    margin-top: -54px;
  }

  .button-bg-color-wed-menu1 {
    background-color: #cbcbcb45;
  }

  .text-color-first-li {
    color: #38558e;
  }

  .icon-star-color {
    color: #f7a53a;
  }

  .th-heading-background {
    background-color: #f4f4f4;
  }

  .button-bg-color-wed {
    background-color: #cbcbcb;
  }

  .input-background {
    background-color: #f8f8f8;
  }

  .white-shadow-box {
    box-shadow: 0px 2px 5px #0000005e;
  }

  .bg-button-color {
    background-color: #cb0000;
  }

  .min-w-min-button {
    min-height: 26px;
    min-width: 53px;
  }

  .max-w-0-menu1 {
    max-width: 4rem;
  }

  .bg-button-color-green {
    background-color: #22af4b;
  }

  .bg-button-color-gray {
    background-color: #636363;
  }

  .bg-hard-grey {
    background-color: #f4f4f4;
  }

  .min-w-min-button-menu1 {
    min-height: 27px;
    min-width: 26px;
    border: 1px solid lightgrey;
  }

  #inputUpload {
    display: none;
  }

  .custom-file-upload {
    cursor: pointer;
    font-size: inherit;
    color: #0c090d;
  }

  .min-h-full-menu1 {
    min-height: 200px;
  }

  .custom-file-upload:hover {
    text-decoration: underline;
  }

  .border-property {
    border: 1px solid gray;
    margin-top: 20px;
    border-style: dashed;
    border-bottom: none;
  }

  .menu1-background-color {
    background-color: #faa43d;
  }

  .menu1-text-color {
    color: #faa43d;
  }

  .min-height-third {
    min-height: 400px;
  }

  .select-menu-height {
    height: 100%;
  }

  .min-height-fivth {
    min-height: 70px;
  }

  .icon-position-menu1 {
    position: absolute;
    top: -5px;
    right: 41px;
  }

  .icon-position-menu2 {
    position: absolute;
    top: -5px;
    right: -3px;
  }

  .position-cross {
    position: absolute;
    right: -21px;
    top: -25px;
    z-index: 1;
    overflow: auto;
  }

  /* .w-4/12-h2 {
  width: 29%;
} */

  .pt-2-space {
    padding-top: 5px;
  }

  .-top-px {
    top: -4px;
  }

  .max-h-650 {
    max-height: 650px;
  }

  .max-h-150 {
    max-height: 150px;
  }

  .expand_recipe {
    transform: rotate(180deg);
  }

  .loader-15 {
    background: currentcolor;
    position: relative;
    animation: loader-15 1s ease-in-out infinite;
    animation-delay: 0.4s;
    width: 0.25em;
    height: 0.5em;
    margin: 37px auto;
  }

  .loader-15:after,
  .loader-15:before {
    content: "";
    position: absolute;
    width: inherit;
    height: inherit;
    background: inherit;
    animation: inherit;
  }

  .loader-15:before {
    right: 0.5em;
    animation-delay: 0.2s;
  }

  .loader-15:after {
    left: 0.5em;
    animation-delay: 0.6s;
  }

  @keyframes loader-15 {

    0%,
    100% {
      box-shadow: 0 0 0 currentcolor, 0 0 0 currentcolor;
    }

    50% {
      box-shadow: 0 -0.25em 0 currentcolor, 0 0.25em 0 currentcolor;
    }
  }
</style>